import './CategoryGamesGridOldSearch.scss';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import AppError from '../../pages/errors/AppError';
import { useFlag } from '../../services/launchDarkly';
import type { Game } from '../../stores/game/types';
import { useStores } from '../../stores/useStores';

import { GameCard } from './GameCard';
import { useGamesSeen } from './hooks/useGamesSeen';
import { useImpressionView } from './hooks/useImpressionView';
import GamesLoader from './Loader';
import MoreGames from './MoreGames';
import { seenGamesGridListener } from './seenGamesImpression';

export const SearchGamesGrid = observer(() => {
  const { t } = useTranslation();
  const { categoriesStore, gamesSearchStore } = useStores();
  const { currentCategory } = categoriesStore;

  const gameLabelFF = useFlag('game_labels_feat', false);

  useImpressionView('search', 'search', gamesSearchStore.activeSearchTerm);
  useGamesSeen(seenGamesGridListener);

  const isLoading = categoriesStore.loading.get('search-games') || categoriesStore.loading.get('pagination');

  if (categoriesStore.loading.get('search-games') || categoriesStore.loading.get('categories')) {
    return <GamesLoader />;
  }

  if (!currentCategory) {
    return <AppError error={new Error('search-games error')} />;
  }

  const noGamesFound = !currentCategory.subCategoryGames.length && !isLoading;

  const filterUniqueGames = (games: Game[]) => {
    const seen = new Set();
    return games.filter((game) => {
      const duplicate = seen.has(game.masterCasinoGameId);
      seen.add(game.masterCasinoGameId);
      return !duplicate;
    });
  };

  const uniqueGames = filterUniqueGames(currentCategory.subCategoryGames);
  const rowName = 'search';

  return (
    <div className="games-grid-wrapper-old-search">
      {noGamesFound && <div className="games-grid__text">{t('games.noGamesFound')}</div>}

      <div className="games-grid-old-search" data-games-row={rowName}>
        {uniqueGames.map((game) => (
          <GameCard key={game.masterCasinoGameId} game={game} gameLabelFF={gameLabelFF} rowName={rowName} />
        ))}
      </div>

      {categoriesStore.loading.get('pagination') ? <GamesLoader /> : currentCategory.hasMoreGames && <MoreGames />}
    </div>
  );
});
